// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-cat-buttons-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.mobile-cat-button {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #F6F7F9;
  border: 2px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
}

.mobile-cat-button:hover {
  background-color: #d3e0fa;
}

.mobile-cat-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}


.mobile-cat-image {
  object-fit: contain; /* Ensures images fill the space without distortion */
  height: 80%;
}


.mobile-cat-name {
  font-size: 1rem;
  color: #333;
}

.button-name{
  margin-top: 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  margin-bottom: 0px;
  height: 20%;
}

.mobile-cat-radio {
  appearance: none;
  width: 14px!important;
  min-width: 14px!important;
  height: 14px!important;
  outline: 4px solid #CED7E4;
  border-radius: 50%; 
  cursor: pointer;
  position: relative;
  background-color: white;
  transition: all 0.3s ease;
}

.mobile-cat-radio:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px!important;
  height: 10px!important;
  background-color: #6294AA;
  border-radius: 50%;
}

.mobile-cat-radio:hover {
  background-color: #d3e0fa!important;
}

.mobile-cat-radio:focus {
  outline: 4px solid #CED7E4;
}

.mobile-subcat-buttons{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F6F7F9;
  padding: 10px;
  gap: 18px
}

.mobile-button{
  height: 50px;
  border: none;
  outline: none;
  background-color: #F6F7F9;
  border-radius: 6px;
}

.mobile-button.active{
  background-color: white;
}


.mobile-product-accordion .accordion-item {
  margin-bottom: 10px;
  border-radius: 6px;
}

.mobile-product-accordion .accordion-header {
  padding: 0 15px;
  height: 50px;
  background-color: #F6F7F9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.accordion-header:hover {
  background-color: #d3e0fa;
}

.mobile-product-accordion .accordion-arrow {
  width: 10px;
  height: 10px;
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.mobile-product-accordion .accordion-arrow.rotated {
  transform: rotate(0deg);
}

.mobile-product-accordion .accordion-content {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: white;
}

.radio-product{
  display: flex;
  justify-content: left;
  align-items: top;
  gap: 10px;
}

.product-title{
    width: 80%;
}


.radio-button-group {
  display: flex;
  gap: 0.5rem;
  justify-content: space-around;
  font-size: 1rem;
  width: 100%;
}

.radio-option {
  position: relative;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  justify-content: flex-start;
}

.radio-input {
  position: absolute;
  bottom: 10px;
  margin: 0;
  opacity: 0;
}

.radio-label {
  text-align: center;
  margin-bottom: 10px;
  font-size: 20px;
}

.mobile-email-input{
  background-color: #F6F7F9;
  height: 50px;
  outline: none;
  border: none;
  color: #666666;
  padding-left: 20px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.mobile-email-input:hover {
  background-color: #d3e0fa;
}

.mobile-email-input::placeholder{
  color: #9ba2ad
}

.mobile-email-input:focus {
  outline: none;
  background-color: #d3e0fa;
}

.radio-row{
  width: 100%;
}



@media (max-width: 700px) {
  .mobile-cat-buttons-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .uk-form-label {
    margin-top: 50px;
  }
}

@media (max-width: 350px) {
  .mobile-cat-name{
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Mobile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB,EAAE,qDAAqD;EAC1E,WAAW;AACb;;;AAGA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;AACX;;AAEA;IACI,UAAU;AACd;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;;;AAIA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".mobile-cat-buttons-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n}\n\n.mobile-cat-button {\n  position: relative;\n  display: block;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  background: #F6F7F9;\n  border: 2px solid transparent;\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.mobile-cat-button:hover {\n  background-color: #d3e0fa;\n}\n\n.mobile-cat-content {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n\n.mobile-cat-image {\n  object-fit: contain; /* Ensures images fill the space without distortion */\n  height: 80%;\n}\n\n\n.mobile-cat-name {\n  font-size: 1rem;\n  color: #333;\n}\n\n.button-name{\n  margin-top: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  width: 100%;\n  margin-bottom: 0px;\n  height: 20%;\n}\n\n.mobile-cat-radio {\n  appearance: none;\n  width: 14px!important;\n  min-width: 14px!important;\n  height: 14px!important;\n  outline: 4px solid #CED7E4;\n  border-radius: 50%; \n  cursor: pointer;\n  position: relative;\n  background-color: white;\n  transition: all 0.3s ease;\n}\n\n.mobile-cat-radio:checked::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 10px!important;\n  height: 10px!important;\n  background-color: #6294AA;\n  border-radius: 50%;\n}\n\n.mobile-cat-radio:hover {\n  background-color: #d3e0fa!important;\n}\n\n.mobile-cat-radio:focus {\n  outline: 4px solid #CED7E4;\n}\n\n.mobile-subcat-buttons{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #F6F7F9;\n  padding: 10px;\n  gap: 18px\n}\n\n.mobile-button{\n  height: 50px;\n  border: none;\n  outline: none;\n  background-color: #F6F7F9;\n  border-radius: 6px;\n}\n\n.mobile-button.active{\n  background-color: white;\n}\n\n\n.mobile-product-accordion .accordion-item {\n  margin-bottom: 10px;\n  border-radius: 6px;\n}\n\n.mobile-product-accordion .accordion-header {\n  padding: 0 15px;\n  height: 50px;\n  background-color: #F6F7F9;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.accordion-header:hover {\n  background-color: #d3e0fa;\n}\n\n.mobile-product-accordion .accordion-arrow {\n  width: 10px;\n  height: 10px;\n  transform: rotate(180deg);\n  transition: transform 0.3s ease;\n}\n\n.mobile-product-accordion .accordion-arrow.rotated {\n  transform: rotate(0deg);\n}\n\n.mobile-product-accordion .accordion-content {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background-color: white;\n}\n\n.radio-product{\n  display: flex;\n  justify-content: left;\n  align-items: top;\n  gap: 10px;\n}\n\n.product-title{\n    width: 80%;\n}\n\n\n.radio-button-group {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: space-around;\n  font-size: 1rem;\n  width: 100%;\n}\n\n.radio-option {\n  position: relative;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  justify-content: flex-start;\n}\n\n.radio-input {\n  position: absolute;\n  bottom: 10px;\n  margin: 0;\n  opacity: 0;\n}\n\n.radio-label {\n  text-align: center;\n  margin-bottom: 10px;\n  font-size: 20px;\n}\n\n.mobile-email-input{\n  background-color: #F6F7F9;\n  height: 50px;\n  outline: none;\n  border: none;\n  color: #666666;\n  padding-left: 20px;\n  font-size: 16px;\n  transition: all 0.3s ease;\n}\n\n.mobile-email-input:hover {\n  background-color: #d3e0fa;\n}\n\n.mobile-email-input::placeholder{\n  color: #9ba2ad\n}\n\n.mobile-email-input:focus {\n  outline: none;\n  background-color: #d3e0fa;\n}\n\n.radio-row{\n  width: 100%;\n}\n\n\n\n@media (max-width: 700px) {\n  .mobile-cat-buttons-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .uk-form-label {\n    margin-top: 50px;\n  }\n}\n\n@media (max-width: 350px) {\n  .mobile-cat-name{\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
